/**
 * HTML/Markdown 変換ツールが本文末尾に付与することがある定型文を除去する。
 */
const WRAPPED_IN_P =
  /<p[^>]*>\s*©\s*Blog Article \(HTML conversion\)\.\s*This file contains only the provided text formatted for web viewing\.\s*<\/p>/gi;

const PLAIN =
  /©\s*Blog Article \(HTML conversion\)\.\s*This file contains only the provided text formatted for web viewing\.?/gi;

export function stripArticleBoilerplate(text: string): string {
  if (!text) return text;
  return text
    .replace(WRAPPED_IN_P, '')
    .replace(PLAIN, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
